import styled from 'styled-components';

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 30px;
`;
